// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1KMrf","empty":"ModalGraph_empty__2-xQx"};